export const CHART_DONUT_INNER_RADIUS = '55%' as const;

/** Max pixel size of dashboard donut (pie area, excluding legend). */
export const CHART_DONUT_DASHBOARD_PIE_MAX_SIZE = 228;

/** Max pixel size of details-page donut (pie area, excluding legend). */
export const CHART_DONUT_DETAILS_PIE_MAX_SIZE = 360;

/** Inset inside the pie box so cornerRadius / highlight are not clipped. */
export const CHART_DONUT_DASHBOARD_INSET = 14;

export const CHART_DONUT_MARGIN = {
  dashboard: {
    top: CHART_DONUT_DASHBOARD_INSET,
    bottom: CHART_DONUT_DASHBOARD_INSET,
    left: CHART_DONUT_DASHBOARD_INSET,
    right: CHART_DONUT_DASHBOARD_INSET,
  },
  details: {
    top: 16,
    bottom: 16,
    left: 16,
    right: 16,
  },
} as const;

export function getChartDonutMargin(
  variant: keyof typeof CHART_DONUT_MARGIN
): (typeof CHART_DONUT_MARGIN)[keyof typeof CHART_DONUT_MARGIN] {
  return CHART_DONUT_MARGIN[variant];
}

export const CHART_AXIS_MARGIN = {
  top: 16,
  bottom: 40,
  left: 40,
  right: 16,
} as const;

export const CHART_GAUGE_VALUE_MIN = 0;
export const CHART_GAUGE_VALUE_MAX = 100;

/** Triplet layout switches to vertical below this width (px). */
export const CHART_TRIPLET_MOBILE_THRESHOLD = 550;

export const CHART_TRIPLET_GAUGE_SIZE = 300;
export const CHART_TRIPLET_CARD_GAUGE_SIZE = 220;
export const CHART_TRIPLET_CARD_COUNT_MAX_WIDTH = 160;
export const CHART_TRIPLET_LAYOUT_HEIGHT = 350;
/** Max width of the triplet row so gauges stay grouped and centered on wide cards. */
export const CHART_TRIPLET_LAYOUT_MAX_WIDTH = 960;
export const CHART_TRIPLET_LAYOUT_MAX_WIDTH_VERTICAL = 360;
